import { getField } from 'vuex-map-fields';
import { roundNumber } from '../../../lib/helpers';
import { calculateBovineTotalValue, getGeneralCalculationType } from '../../../lib/sales';

export default {
    getField,
    totalValueByBovine: ({ formData }) => {
        return formData.bovines.reduce((total, bovine) => {
            total[bovine.bovineId] = calculateBovineTotalValue(bovine);
            return total;
        }, {});
    },
    totalValue: (state, getters) => {
        return Object.values(getters.totalValueByBovine).reduce((total, value) => total + value, 0);
    },
    averageValue: ({ formData }, getters) => {
        return roundNumber(getters.totalValue / formData.bovines.length);
    },
    averageKgValue: (state, getters) => {
        return getters.totalWeight ? roundNumber(getters.totalValue / getters.totalWeight) : 0;
    },
    totalWeight: ({ formData }) => {
        return formData.bovines.reduce((total, bovine) => total + (Number(bovine.weight) || 0), 0);
    },
    averageWeight: ({ formData }, getters) => {
        return roundNumber(getters.totalWeight / formData.bovines.length);
    },
    totalGeneralValue: ({ formData }, getters) => {
        if (formData.generalValue.typeId === 3) {
            return roundNumber(formData.generalValue.value * formData.bovines.length);
        }
        return calculateBovineTotalValue({
            calculationTypeId: getGeneralCalculationType(formData.generalValue.typeId),
            weight: getters.totalWeight,
            value: formData.generalValue.value,
            arrobaWeight: formData.generalValue.arrobaWeight,
        });
    },
    isBuyerStepValid({ formData }) {
        return !!formData.buyer.name;
    },
    isBovineStepValid({ formData }) {
        return !!formData.bovines.length;
    },
    isValueStepValid({ formData }) {
        return !!formData.bovines.length && formData.bovines.every((bovine) => bovine.value);
    },
};
